import * as React from 'react';
import { OptionsType, ValueType } from 'react-select/src/types';
import { DARK_PLACEHOLDER, getNewValue } from '../../../../constants';
import InputDropdown from '../../../../widgets/InputDropdown';
import { FilterDropdownProps } from './AdditionalFilterBar';
import { OptionType } from '../../../../types';

export type Props = {
  label: string;
  filterKey: string;
  minWidth: number;
  options: Array<string> | null;
  placeholder: string;
  tooltip?: any;
} & FilterDropdownProps;

export default class DataFilterDropdown extends React.Component<Props> {
  stringsToOptions = (strings: Array<string>): OptionsType<OptionType> => {
    return strings.map((str) => ({ label: str, value: str }));
  };

  handleSelectChange = (value: ValueType<OptionType>) => {
    const { setFilter, filterKey } = this.props;
    const v = getNewValue(value, true);
    setFilter(filterKey, v && v.map((sel) => sel.value).join(','));
  };

  render() {
    const { label, minWidth, options, placeholder, tooltip, value, filterKey } =
      this.props;
    return (
      <div className="pr-3 pt-3" style={{ minWidth: minWidth + 'px' }}>
        <h5>
          {label}
          {tooltip}
        </h5>

        <InputDropdown
          classNamePrefix={`${filterKey}-filter`}
          isCreatable={true}
          isMulti={true}
          noOptionsMessage={() => 'No suggestions'}
          onChange={this.handleSelectChange}
          options={this.stringsToOptions(options || [])}
          placeholder={placeholder}
          value={value ? this.stringsToOptions(value.split(',')) : null}
          styles={DARK_PLACEHOLDER}
        />
      </div>
    );
  }
}
